import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentBoardState, useCurrentUser } from '../../services/state';
import { login as deepstreamLogin } from '../../services/deepstream';
import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';
import UnauthorizedModal from './UnauthorizedModal';

const DeepstreamProvider = ({ children }) => {
  const { id: userId } = useCurrentUser();
  const { boardId } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const boardState = useCurrentBoardState();

  useEffect(() => {
    deepstreamLogin({ userId, boardId })
      .then(async ({ userRole }) => {
        setIsLoggedIn(true);
        boardState.merge({ id: boardId, userRole });
      })
      .catch(error => {
        if (error.reason === 'INVALID_AUTHENTICATION_DETAILS') {
          setErrorModalVisible(true);
        } else {
          console.log('unknown deepstream error', error);
          //setErrorModalVisible(true);
        }
      });

    return () => {
      setIsLoggedIn(false);
    };
  }, [userId, boardId]);

  if (errorModalVisible) {
    return <UnauthorizedModal isOpen={errorModalVisible} />;
  }

  if (!isLoggedIn) {
    return (
      <div style={{ textAlign: 'left' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return children;
};

export default DeepstreamProvider;
